import TCDetailHeader from "@components/TravelConsultants/TCDetailHeader";
import { ITopNavigationResponse } from "@customTypes/commonResponses";
import { IImageComponentResponse } from "@customTypes/componentResponses";
import { ITagResponse } from "@customTypes/modelResponses";
import DetailsPageSectionsWrapper from "@modules/detailsPage/DetailsPageSectionsWrapper";
import dynamic from "next/dynamic";
import { RaQFormType, RaQPageType } from "pages/things-to-do/[...slug]";

const DetailPageLayout = dynamic(
  async () => await import("@components/common/DetailPageLayout"),
  { ssr: false }
);

const TCReviewsSection = dynamic(
  async () => await import("@components/TravelConsultants/TCReviewsSection"),
  { ssr: false }
);

export interface ITidbit {
  id: number;
  text: string;
}

export interface ISpecialtyTag {
  id: number;
  name: string;
}

export interface IReview {
  id: number;
  name: string;
  headshot: string | undefined;
  text: JSX.Element | JSX.Element[];
  country: string;
  date?: string | null;
}

export interface ITravelConsultant {
  name?: string;
  image?: IImageComponentResponse;
  jobTitle?: string;
  bio?: string | JSX.Element | JSX.Element[];
  tidbits?: ITidbit[];
  specialties?: ITagResponse[];
  reviews?: IReview[];
}

interface ITCDetailLayout {
  raqFormProps: {
    topNavigation: ITopNavigationResponse;
    raqFormType: RaQFormType;
    pageType: RaQPageType;
  };
  travelConsultant: ITravelConsultant;
}

const TCDetailsLayout = ({
  raqFormProps,
  travelConsultant,
}: ITCDetailLayout): JSX.Element => {
  return (
    <>
      <TCDetailHeader travelConsultant={travelConsultant} />
      <DetailPageLayout hasSeperateHeader>
        <DetailsPageSectionsWrapper
          topNavigation={raqFormProps.topNavigation}
          raqFormType={raqFormProps.raqFormType}
          pageType={raqFormProps.pageType}
        >
          <>
            <div className="mx-5 desktop:mx-0">{travelConsultant.bio}</div>
            <>
              {travelConsultant.reviews &&
                travelConsultant.reviews.length > 0 && (
                  <TCReviewsSection reviews={travelConsultant.reviews} />
                )}
            </>
          </>
        </DetailsPageSectionsWrapper>
      </DetailPageLayout>
    </>
  );
};

export default TCDetailsLayout;
